import script from "./SegmentCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./SegmentCreate.vue?vue&type=script&setup=true&lang=js"

import "./SegmentCreate.vue?vue&type=style&index=0&id=8b59bdd0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b59bdd0"]])

export default __exports__